// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*------------------------------------------
  Responsive Grid Media Queries - 1280, 1024, 768, 480
   1280-1024   - desktop (default grid)
   1024-768    - tablet landscape
   768-480     - tablet 
   480-less    - phone landscape & smaller
--------------------------------------------*/
/* Large screens - DESKTOP */
/* min-width 1025px, large screens */
/* min-width 1024px and max-width 1440px, use when QAing large screen-only issues */
/* XLarge screens */
/* min-width 1441px, xlarge screens */
/* min-width 1441px and max-width 1920px, use when QAing xlarge screen-only issues */
/* XXLarge screens */
/* min-width 1921px, xlarge screens */
/*------------------------------------------*/
.mt-auto {
  background-color: #F9F9F9 !important;
}

.fa-home:before {
  content: "" !important;
  color: transparent;
  background-image: url(http://localhost:4200/assets/img/icons/icon-dashboard.PNG);
  background-size: 16px 16px;
  background-repeat: no-repeat;
}

@media all and (min-width: 992px) and (max-width: 1280px) {
  .mt-auto-custom {
    display: none;
  }
}
@media only screen and (min-width: 64.063em) {
  .mt-auto-custom {
    display: none;
  }
}
@media only screen and (min-width: 64.063em) and (max-width: 90em) {
  .mt-auto-custom {
    display: none;
  }
}
@media only screen and (min-width: 90.063em) {
  .mt-auto-custom {
    display: none;
  }
}
@media only screen and (min-width: 90.063em) and (max-width: 120em) {
  .mt-auto-custom {
    display: none;
  }
}
@media only screen and (min-width: 120.063em) {
  .mt-auto-custom {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/containers/components/app-sidebar-nav/app-sidebar-nav.component.scss"],"names":[],"mappings":"AAAA;;;;;;6CAAA;AAOA,4BAAA;AACA,oCAAA;AACA,mFAAA;AACA,mBAAA;AACA,qCAAA;AACA,oFAAA;AACA,oBAAA;AACA,qCAAA;AACA,6CAAA;AACA;EACC,oCAAA;AACD;;AAEA;EACC,sBAAA;EACG,kBAAA;EACA,gFAAA;EACA,0BAAA;EACA,4BAAA;AACJ;;AAEA;EACC;IACC,aAAA;EACA;AACF;AACA;EACC;IACC,aAAA;EACA;AACF;AACA;EACC;IACC,aAAA;EACA;AACF;AACA;EACC;IACC,aAAA;EACA;AACF;AACA;EACC;IACC,aAAA;EACA;AACF;AACA;EACC;IACC,aAAA;EACA;AACF","sourcesContent":["/*------------------------------------------\n  Responsive Grid Media Queries - 1280, 1024, 768, 480\n   1280-1024   - desktop (default grid)\n   1024-768    - tablet landscape\n   768-480     - tablet \n   480-less    - phone landscape & smaller\n--------------------------------------------*/\n/* Large screens - DESKTOP */\n/* min-width 1025px, large screens */\n/* min-width 1024px and max-width 1440px, use when QAing large screen-only issues */\n/* XLarge screens */\n/* min-width 1441px, xlarge screens */\n/* min-width 1441px and max-width 1920px, use when QAing xlarge screen-only issues */\n/* XXLarge screens */\n/* min-width 1921px, xlarge screens */\n/*------------------------------------------*/\n.mt-auto {\n\tbackground-color: #F9F9F9 !important;\n}\n\n.fa-home:before {\n\tcontent: '' !important;\n    color: transparent ;\n    background-image: url(http://localhost:4200/assets/img/icons/icon-dashboard.PNG) ;\n    background-size: 16px 16px ;\n    background-repeat: no-repeat ;\n}\n\n@media all and (min-width: 992px) and (max-width: 1280px) {\n\t.mt-auto-custom {\n\t\tdisplay: none;\n\t}\n}\n@media only screen and (min-width: 64.063em) {\n\t.mt-auto-custom {\n\t\tdisplay: none;\n\t}\n}\n@media only screen and (min-width: 64.063em) and (max-width: 90em) {\n\t.mt-auto-custom {\n\t\tdisplay: none;\n\t}\n}\n@media only screen and (min-width: 90.063em) {\n\t.mt-auto-custom {\n\t\tdisplay: none;\n\t}\n}\n@media only screen and (min-width: 90.063em) and (max-width: 120em) {\n\t.mt-auto-custom {\n\t\tdisplay: none;\n\t}\n}\n@media only screen and (min-width: 120.063em) {\n\t.mt-auto-custom {\n\t\tdisplay: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
